import React from 'react';
import classNames from 'classnames';
import { Heading } from '../../components';

import css from './CustomExtendedDataSection.module.css';

const SectionSocialPlatforms = props => {
  const { heading, options = [], selectedOptions = [], followerCounts = {}, className, rootClassName } = props;

  const activeOptions = options.filter(o => selectedOptions.includes(o.key));

  if (!heading || activeOptions.length === 0) {
    return null;
  }

  const classes = classNames(rootClassName || css.sectionMultiEnum, className);

  return (
    <section className={classes}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.socialPlatformList}>
        {activeOptions.map(option => {
          const count = followerCounts[`followers_${option.key}`];
          return (
            <li key={option.key} className={css.socialPlatformRow}>
              <span className={css.socialPlatformName}>{option.label}</span>
              {count != null ? (
                <span className={css.socialPlatformCount}>
                  {Number(count).toLocaleString()}
                </span>
              ) : null}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionSocialPlatforms;
